<template>	

		<div v-show='getFonds() && getFonds()["pensioenfonds"] !== "StiPP"' class="knd-pensioenswarms">
			<h2>JOUW PENSIOENFONDS TEN OPZICHTE VAN DE ANDERE</h2>
			<p v-if="selectedFonds">We hebben op een rijtje gezet waarin <span class="fonds-selected">{{ getFonds()["pensioenfonds"] }}</span> heeft geïnvesteerd. Hieronder zie je in hoeveel steenkoolbedrijven de pensioenfondsen investeren. Elk bolletje is een pensioenfonds.</p>

			<div 
				class="grafiek-container voorbeeld visible"
				ref="voorbeeldGrafiekContainer">
			</div>


			<div 
				v-for="(grafiek, index) in grafieken"
				:key="index + '-grafiek'">

				<h4 v-if='grafiek["soort"] != ""' v-html='grafiek["soort"]'></h4>
				<div 
					class="knd-grafiek-titel"
					@click="showGrafiek(index)"
					v-if="selectedFonds">
					<p>{{ grafiek["tekst"] }}</p>
					<img 
						class="knd-grafiek-icon" 
						ref="knd-grafiek-icon"
						:src="require('@/assets/img/arrow-down.svg')" 
						alt="" />
				</div>

				<div 
					class="grafiek-container"
					:ref="'grafiekContainer' + index">
				</div>
			</div>
		</div>

</template>

<script>
	import './pensioenswarms.scss';

	import Swarm from './swarm';

	export default {
		name: 'Colofon',
		computed: {
		},
		data: function() {
			return {
				content: this.$store.state.content,
				data: this.$store.state.data,
				swarms: [],
				selectedFonds: this.$store.getters.selectedFonds,
				grafieken: [
					{
						key: "totaal_euro_coal",
						tekst: "Per deelnemer geïnvesteerd in steenkoolindustrie, in euro",
						soort: "Steenkool"
					},
					{
						key: "aantal_uitbreidingsplannen_steenkool_winning",
						tekst: "Aantal bedrijven dat nieuwe mijnen wil openen of uitbreiden",
						soort: ""
					},
					{
						key: "totaal_euro_upstream",
						tekst: "Per deelnemer geïnvesteerd in olie- en gaswinning, in euro",
						soort: "Winning van olie en gas"
					},
					{
						key: "aantal_meerdan_10mln_inv_zoeken",
						tekst: "Aantal bedrijven dat flink investeert in het zoeken naar nieuwe bronnen (meer dan 10 miljoen in de afgelopen drie jaar)",
						soort: ""
					},
					{
						key: "totaal_euro_midstream",
						tekst: "Per deelnemer geïnvesteerd in olie- en gastransport, in euro",
						soort: "Transport van olie en gas"
					},
					{
						key: "totale_lengte_pijpleiding",
						tekst: "Totale lengte van geplande olie of gas pijpleidingen, in km",
						soort: ""
					}
				]
			}
		},
		mounted() {
			if (this.data) {
				console.log("grafiekendata: ", this.data);
			}

					
		},
		watch: {
			'$store.state.selectedFonds': {
				deep: true,
				handler(newVal) {
					this.selectedFonds = this.getFonds();

					window.setTimeout(() => { //fix zet kinesis elementen goed
						this.maakGrafiekjes();
					}, 500);
				}
			}
		},
		methods: {
			getContent(content, label) {
				// if (this.$store.state.language === "nl") {
					return content[label].data;
				// }
				// else {
					// return content[label].data5891;	
				// }
			},

			maakGrafiekjes() {
				const newSwarm = new Swarm()
					.container(this.$refs["voorbeeldGrafiekContainer"])
					.key("totaal_bedrijven_coal")
					.data(this.data)
					.selected(this.selectedFonds["pensioenfonds"])
					.render("eerste");

				this.grafieken.forEach((grafiek, index) => {
					const newSwarm = new Swarm()
						.container(this.$refs["grafiekContainer" + index][0])
						.key(grafiek.key)
						.data(this.data)
						.selected(this.selectedFonds["pensioenfonds"])
						.render();
					this.swarms.push(newSwarm);
				});
			},

			getFonds() {
				return this.$store.getters.selectedFonds;
			},

			showGrafiek(index) {
				this.$refs["grafiekContainer" + index][0].classList.toggle("visible");
				this.$refs["knd-grafiek-icon"][index].classList.toggle("draai");
				this.maakGrafiekjes();
			}
		}
	}
</script>